// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3KbCZ","inputWrap":"CustomTip_inputWrap__3pH19"};